import { transformPrivacySettingsFormatFromApiToSchema } from '../transformers/manage-user-privacy-settings';
const UserManagePrivacySettings = async (_, args, context, info) => {
  const {
    userId
  } = args;
  const url = `${context.url.stargateRoot}/users/${userId}/manage/privacy-settings`;
  return context.fetch(url).then(data => data.json()).then(data => transformPrivacySettingsFormatFromApiToSchema(data)).then(data => ({
    ...data,
    id: userId
  }));
};
export default UserManagePrivacySettings;